import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import { Media, Row, Col, Container } from "reactstrap";
import aboutImg from '../../../resources/custom/images/about-us.jpg';
import CustomerTestimonial from '../../components/shared/CustomerTestimonial';

const About = () => {
  const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);

  return (
    <>


      <Helmet>
        <title>{siteTitle} - About Us</title>
        <meta name="description" content={siteTitle + " - About us page"}  />
        <meta name="keywords" content="About us"></meta>
      </Helmet>

      <SiteBreadcrumb title="About-Us" parent="Home"/>

      <section className="about-page section-big-py-space">
        <div className="custom-container">
          <Row>
            <Col lg="6">
              <div className="banner-section">
                <Media src={aboutImg} className="img-fluid w-100" alt="" />
              </div>
            </Col>
            <Col lg="6">
             
              <p className="mb-2">
                {" "}
                Welcome to <b>UKL Butter</b> from Uthukuli!
              </p>
              <p className="mb-2">
                {" "}
                We are farmers from Uthukuli, a small town in Tamil Nadu, India. Our family-owned farm produces high-quality butter known for its rich flavor and creamy texture.
              </p>
              <p className="mb-2">
                {" "}
                Our butter's unique qualities stem from the region's rich dairy farming heritage. The cows and buffaloes in Uthukuli are fed a nutritious diet of maize stalks, bran, and oilcake, resulting in milk that is high in fat and rich in flavor.
              
              </p>
              <p className="mb-2">
                {" "}
                Unlike other butters, Uthukuli butter has a slightly tangy taste and a matte finish. Its remarkable shelf life, up to a month at room temperature, is a testament to its purity and traditional production methods.
              </p>
              <p className="mb-2">
                {" "}
                
We have start small initiative to reach you. Not for Profit it is all about health and original product.


              </p>
            </Col>
          </Row>
        </div>
      </section>

      <CustomerTestimonial />

    </>
  );

}

export default About;
